var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entry)?_c('div',{staticClass:"entry-wrapper"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.entry.title))]),_c('hr')]),_c('div',[_c('div',{staticClass:"page",domProps:{"innerHTML":_vm._s(_vm.entry.body)}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-126d66e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Entry.vue
// module id = null
// module chunks = 